module.exports = __webpack_public_path__ + "static/media/no_search_mall.3e073329.png";